import { apiClient } from '../../../core/apiClient';
import { API_CONFIG } from '../../../core/apiConfig';
import type { ApiResponse } from '../../../shared';
import type { LC_CreateEmployeeIn } from '../types';

/**
 * Service for employee creation operations
 */
class EmployeeCreateService {
  /**
   * Creates a new employee
   * @param input Employee data to create
   * @returns ApiResponse with empty body on success or error
   * 
   * Response codes:
   * - 200: Employee created successfully (empty body)
   * - 400: Validation error (VALIDATION_ERROR)
   * - 409: Conflict - duplicate RUT or email (CONFLICT_DUPLICATE_EMPLOYEE)
   * - 500: Internal server error
   */
  async create(input: LC_CreateEmployeeIn): Promise<ApiResponse<void>> {
    return apiClient.post<void>(API_CONFIG.ENDPOINTS.EMPLOYEES.CREATE, input);
  }
}

export const employeeCreate = new EmployeeCreateService();
